import React, { FC } from 'react';
import FormInput from './formcontrols/formInput';
import FormSelect from './formcontrols/formSelect';
import FormCheckbox from './formcontrols/formCheckbox';
import { IForm } from './formInterface';
import FormTextArea from './formcontrols/formTextArea';

/**
 * This container is meant for Registration Form.
 * Similarly, we can create container for other forms as per usecase but reusing the form controls under formcontrols
 * directory.
 */
const RegFormContainer: FC<IForm> = (props) => {
  const { controlType, noOfFields, wrapperStyle, ...rest } = props;

  /* Handling adaptive styling commonly for all fields except checkbox.
   * If we require to handle for specific control. We can move this logic
   * to their respective case statements. */
  const adaptiveStyling =
    noOfFields && noOfFields > 4
      ? { className: 'small-field-box', size: 'sm' }
      : { className: 'field-box', size: 'md' };

  switch (controlType) {
    case 'Input':
      return (
        <div className={adaptiveStyling.className} style={wrapperStyle}>
          <FormInput size={adaptiveStyling.size} {...rest} />
        </div>
      );

    case 'TextArea':
      return (
        <div className={adaptiveStyling.className}>
          <FormTextArea
            maxLength="128"
            size={noOfFields && noOfFields > 4 ? 'small' : 'large'}
            resize="vertical"
            {...rest}
          />
        </div>
      );

    case 'Dropdown':
      return (
        <div className={adaptiveStyling.className}>
          <FormSelect size={adaptiveStyling.size} {...rest} />
        </div>
      );

    case 'Checkbox':
      return (
        <div style={{ marginTop: '16px', marginBottom: '16px' }}>
          <FormCheckbox size="medium" {...rest}>
            {props.children}
          </FormCheckbox>
        </div>
      );

    default:
      return null;
  }
};

export default RegFormContainer;
